export default () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Notepad-Sketchpad--Streamline-Flex"
    >
        <desc>
            {'Notepad Sketchpad Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="notepad-sketchpad">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.922871 10.5516c0.165949 1.4253 1.369349 2.5569 2.857439 2.6259 1.02855 0.0477 2.07925 0.0725 3.21959 0.0725 1.14035 0 2.19104 -0.0248 3.2196 -0.0725 1.4881 -0.069 2.6915 -1.2006 2.8574 -2.6259 0.2305 -1.97953 0.2305 -3.6653 0 -5.64487 -0.1659 -1.42526 -1.3693 -2.55689 -2.8574 -2.62588 -1.02855 -0.04769 -2.07925 -0.07248 -3.2196 -0.07248 -1.14034 0 -2.19104 0.02479 -3.21959 0.07248 -1.48809 0.06899 -2.69149 1.20062 -2.857439 2.62588 -0.230495 1.97957 -0.230494 3.66534 0 5.64487Z"
                strokeWidth={1}
            />
            <path
                id="Line 3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m4.25195 0.75 0 2.75"
                strokeWidth={1}
            />
            <path
                id="Line 4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m9.74805 0.75 0 2.75"
                strokeWidth={1}
            />
            <path
                id="vector 2056"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.33695 5.96948c-0.95064 1.38746 -1.76689 3.6075 -0.76863 3.60744 0.99826 -0.00006 2.60723 -2.52261 3.36628 -2.52267 0.75905 -0.00005 -1.36972 2.52267 -0.23898 2.52261 1.13074 -0.00006 1.77554 -1.26974 2.58372 -1.29213 0.80816 -0.0224 -1.05299 1.51127 1.60896 1.29213"
                strokeWidth={1}
            />
        </g>
    </svg>
);
